var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employer-services-extension extension"},[_c('Banner'),_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }